import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip, Stack } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { ValidationCounts } from '../utils/validation/createValidationSummary';
type ValidationSummaryProps = {
  counts?: ValidationCounts;
};

// ValidationSummary component to display counts at the section level
export const ValidationSummary = ({ counts }: ValidationSummaryProps) => {
  const { t } = useTranslation();

  if (!counts || (counts.errors === 0 && counts.warnings === 0)) {
    return null;
  }

  return (
    <Stack direction='row' spacing={1} sx={{ ml: 2 }}>
      {counts.errors > 0 && (
        <Chip
          icon={<ErrorIcon />}
          label={`${counts.errors} ${
            counts.errors === 1 ? t('error') : t('errors')
          }`}
          color='error'
          size='small'
        />
      )}
      {counts.warnings > 0 && (
        <Chip
          icon={<WarningAmberIcon />}
          label={`${counts.warnings} ${
            counts.warnings === 1 ? t('warning') : t('warnings')
          }`}
          color='warning'
          size='small'
        />
      )}
    </Stack>
  );
};
